/* eslint-disable react-hooks/exhaustive-deps */
import { Helmet } from "react-helmet-async";
import React, { useEffect, useState } from "react";

import {
  Card,
  Table,
  Stack,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Grid,
  TablePagination,
} from "@mui/material";
import TableHeader from "./table-header";
import TableToolbar from "./table-toolbar";
import { GET, POST } from "../../../config/https";
import APIS from "../../../config/api";
import FullScreenLoader from "../../../components/full-screen-loader";
import { Icon } from "@iconify/react";
import NumberFormat from "../../../components/number-format";
import { AppCurrentVisits } from "../../../sections/@dashboard/app";
import Color from "../../../theme/color";
import { GetLocalStorage } from "../../../utils/local-storage";
import { usePersistentState } from "../../../contexts/global-context";
import { STRING } from "../../../resources/string";
import { marginBottomSize } from "../../../utils/constant";
import { NumericFormat } from "react-number-format";

const TABLE_HEAD = [
  { id: "ticketsSoldByCc", label: "Tickets sold by CC", alignRight: false },
  { id: "eventName", label: "Ticket sales through CC", alignRight: false },
  { id: "customerName", label: "Service fee through CC", alignRight: false },
  { id: "email", label: " Sales tax through CC", alignRight: false },
  { id: "phone", label: "Tickets sold by Zelle", alignRight: false },
  { id: "noOfTicket", label: "Ticket sales through Zelle", alignRight: false },
  { id: "paymentType", label: "Service fee through Zelle", alignRight: false },
  { id: "status", label: " Sales tax through Zelle", alignRight: false },
  { id: "amount", label: " Tickets sold by Pay to Host", alignRight: false },
  {
    id: "action",
    label: "Ticket sales through Pay to Host",
    alignRight: false,
  },
];
const TABLE_HEADS = [
  { id: "ticketType", label: "Ticket Type", alignRight: false },
  { id: "totalTickets", label: "# Total Tickets", alignRight: false },
  { id: "soldTickets", label: "# Sold Tickets", alignRight: false },
  { id: "freeTickets", label: "# Free Tickets", alignRight: false },
  { id: "checkIn", label: "# Check In", alignRight: false },
];
interface SalesData {
  revenue: number;
  salesReports: {
    id: string;
    ticketType: string;
    totalTickets: number;
    soldTickets: number;
    freeTickets: number;
    revenue: number;
  }[];
}
export default function SalesReport() {
  const [state]: any = usePersistentState();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [eventList, setEventList] = useState([]);
  const [selected] = useState<any>([]);
  const [pagination, setPagination] = useState<any>();
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [filterEvent, setFilterEvent] = useState<any>([]);
  const filterEventId = filterEvent?.id;
  const [loader, setLoader] = useState(false);
  const [allSalesReport, setAllSalesReport] = useState([]);
  const [loginInfo, setLoginInfo] = useState<any>(false);
  const [skipCount, setSkipCount] = useState(true);
  const [salesConsolidatedReport, setSalesConsolidatedReport] = useState<any>(
    {}
  );

  const [allSalesData, setAllSalesData] = useState<SalesData>({
    revenue: 0,
    salesReports: [],
  });
  useEffect(() => {
    setLoader(true);
    GetEventDropdown();
    GetSalesConsolidatedReport();
    GetSalesData(10, 0);
    setLoader(false);
  }, []);

  useEffect(() => {
    if (skipCount) {
      setSkipCount(false);
    } else {
      GetSalesData(rowsPerPage, page);
      GetSalesReport();
    }
    if (filterEventId) {
      GetSalesConsolidatedReport();
    }
  }, [filterEventId, rowsPerPage, page]);

  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData);
  }, [state.users]);

  const getOrganizerId = async () => {
    const userData = await GetLocalStorage("loginData");

    if (userData?.roles?.id === 1) {
      return "";
    }
    if (userData?.roles?.id === 2) {
      return userData?.id;
    }
  };

  const GetEventDropdown = async () => {
    let organizerId = await getOrganizerId();
    await GET(APIS.GET_ALL_EVENTS + "?OrganizerId=" + organizerId)
      .then((res: any) => {
        if (res?.isSuccess) {
          setEventList(res.result);
        }
      })
      .catch((error) => {});
  };

  const GetSalesReport = async () => {
    setLoader(true);
    let param = {
      eventId: filterEventId,
    };
    await POST(APIS.SALES_REPORT, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          setAllSalesReport(res?.result);
          setLoader(false);
        }
      })
      .catch(() => {
        console.log("error");
        setLoader(false);
      });
  };

  const GetSalesConsolidatedReport = async () => {
    setLoader(true);

    const eventId = filterEventId || "";
    await GET(APIS.SALES_CONSOLIDATED_REPORT + "?" + "EventId=" + eventId)
      .then((res: any) => {
        setSalesConsolidatedReport(res);
        setLoader(false);
      })
      .catch(() => {
        console.log("error");
        setLoader(false);
      });
  };

  const GetSalesData = async (rowsPerPage?: any, pageNumber?: any) => {
    setLoader(true);
    const eventId = filterEventId || "";
    await GET(
      APIS.GET_DASHBOARD_DATA +
        "?" +
        "EventId=" +
        eventId +
        "&PageNumber=" +
        pageNumber +
        "&PageSize=" +
        rowsPerPage
    )
      .then((res: any) => {
        setPagination(res);
        if (res?.isSuccess) {
          setAllSalesData(res?.result);
          setLoader(false);
        }
      })
      .catch(() => {
        console.log("error");
        setLoader(false);
      });
  };

  const handleOnChange = (newValue: any) => {
    setFilterEvent(newValue);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleFilterByName = (event: any) => {
    setPage(0);
    setFilterName(event.target.value);
  };
  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  return (
    <>
      <Helmet>
        <title> SalesReport | EventPrix </title>
      </Helmet>

      <Container maxWidth={"xl"} style={{ marginBottom: marginBottomSize }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Icon
              width="30"
              height="30"
              style={{ marginRight: 5 }}
              icon="icon-park-outline:sales-report"
            />
            <Typography variant="h4">Dashboard</Typography>
          </div>
        </Stack>

        <Card style={{ marginTop: "20px" }}>
          <TableToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            category={eventList}
            onChange={(newValue: any) => {
              handleOnChange(newValue);
            }}
            revenue={allSalesData?.revenue}
          />
          <Grid
            container
            style={{ padding: " 0px 16px 16px 16px" }}
            spacing={2}
          >
            <Grid item xs={12} md={6} lg={6}>
              <AppCurrentVisits
                title={`Total Tickets (${
                  salesConsolidatedReport?.totalTickets || 0
                })`}
                chartData={[
                  {
                    label: `Unsold Tickets `,
                    value: salesConsolidatedReport?.unSoldTickets || 0,
                  },
                  {
                    label: `Sold Tickets `,
                    value: salesConsolidatedReport?.soldTickets || 0,
                  },
                  {
                    label: `Free Tickets `,
                    value: salesConsolidatedReport?.freeTickets || 0,
                  },
                ]}
                chartColors={[Color.primary, "#44B408", Color.secondary]}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Card>
                <TableContainer
                  sx={{ minWidth: 250, overflow: "auto", minHeight: 410 }}
                >
                  <Table>
                    <TableHeader
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEADS}
                      onRequestSort={handleRequestSort}
                    />
                    {allSalesData.salesReports.length === 0 ? (
                      <TableBody style={{ height: "355px" }}>
                        <TableRow>
                          <TableCell align="center" colSpan={15} sx={{ py: 4 }}>
                            <Paper
                              sx={{
                                textAlign: "center",
                              }}
                            >
                              <Typography variant="h6" paragraph>
                                No Data found
                              </Typography>
                            </Paper>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : (
                      <TableBody>
                        {allSalesData?.salesReports?.map(
                          (data: any, index: any) => {
                            const {
                              id,
                              ticketType,
                              totalTickets,
                              soldTickets,
                              freeTickets,
                              checkIn,
                              soldTicketsByCardOrZelle,
                              soldTicketsPayToHost,
                            } = data;

                            const total =
                              soldTicketsByCardOrZelle + soldTicketsPayToHost;

                            return (
                              <React.Fragment key={index}>
                                <TableRow key={id}>
                                  <TableCell align="center">
                                    {ticketType}
                                  </TableCell>
                                  <TableCell align="center">
                                    <NumericFormat
                                      value={totalTickets}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      thousandsGroupStyle="lakh"
                                      fixedDecimalScale={true}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <NumericFormat
                                      value={total}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      thousandsGroupStyle="lakh"
                                      fixedDecimalScale={true}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <NumericFormat
                                      value={freeTickets}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      thousandsGroupStyle="lakh"
                                      fixedDecimalScale={true}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <NumericFormat
                                      value={checkIn}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      thousandsGroupStyle="lakh"
                                      fixedDecimalScale={true}
                                    />
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            );
                          }
                        )}
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={pagination?.totalRecords ?? 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  style={{ overflow: "auto" }}
                />
              </Card>
            </Grid>
          </Grid>
          <FullScreenLoader open={loader} />
        </Card>
        {loginInfo?.roles?.name === STRING.ROLE.HOSTS ? null : (
          <Card style={{ marginTop: "20px" }}>
            <TableContainer
              sx={{ minWidth: 300, overflow: "auto", minHeight: 300 }}
            >
              <Table>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  onRequestSort={handleRequestSort}
                />
                {allSalesReport.length === 0 ? (
                  <TableBody style={{ height: "200px" }}>
                    <TableRow>
                      <TableCell align="center" colSpan={10} sx={{ py: 4 }}>
                        <Paper
                          sx={{
                            textAlign: "center",
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            No Data found
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {allSalesReport?.map((order: any, index: any) => {
                      const {
                        id,
                        totalTicketsSoldByCC,
                        ticketSalesThroughCC,
                        serviceFeeThroughCC,
                        salesTaxThroughCC,
                        totalTicketsSoldByZelle,
                        ticketSalesThroughZelle,
                        serviceFeeThroughZelle,
                        salesTaxThroughZelle,
                        totalTicketsSoldByPayToHost,
                        ticketSalesThroughPayToHost,
                      } = order;

                      return (
                        <React.Fragment key={index}>
                          <TableRow>
                            <TableCell align="center">
                              {totalTicketsSoldByCC}
                            </TableCell>
                            <TableCell align="center">
                              $<NumberFormat total={ticketSalesThroughCC} />
                            </TableCell>
                            <TableCell align="center">
                              $<NumberFormat total={serviceFeeThroughCC} />
                            </TableCell>
                            <TableCell align="center">
                              $<NumberFormat total={salesTaxThroughCC} />
                            </TableCell>
                            <TableCell align="center">
                              {totalTicketsSoldByZelle}
                            </TableCell>
                            <TableCell align="center">
                              $<NumberFormat total={ticketSalesThroughZelle} />
                            </TableCell>
                            <TableCell align="center">
                              $<NumberFormat total={serviceFeeThroughZelle} />
                            </TableCell>
                            <TableCell align="center">
                              $<NumberFormat total={salesTaxThroughZelle} />
                            </TableCell>
                            <TableCell align="center">
                              {totalTicketsSoldByPayToHost}
                            </TableCell>
                            <TableCell align="center">
                              $
                              <NumberFormat
                                total={ticketSalesThroughPayToHost}
                              />
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                  </TableBody>
                )}
              </Table>
            </TableContainer>

            <FullScreenLoader open={loader} />
          </Card>
        )}
      </Container>
    </>
  );
}
